'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarHeader from 'ContentEditorUI/components/sidebar/SidebarHeader';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Sidebar extends Component {
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "expanding-sidebar",
      children: /*#__PURE__*/_jsxs("div", {
        className: "sidebar-content",
        id: "inpage-sidebar-container",
        children: [/*#__PURE__*/_jsx(SidebarHeader, {}), /*#__PURE__*/_jsx(View, {
          position: "relative",
          blockSize: "100%",
          children: this.props.children
        })]
      })
    });
  }
}
Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string,
  isReadOnlyMode: PropTypes.bool.isRequired
};